import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/main.jsx';
import PropTypes from 'prop-types';
import {canUseDOM} from '../../../helpers/canUseDOM';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INTERACTIVE,
            tab: 'recommended',
            isMobile: canUseDOM ? window.innerWidth <= 450 : false,
            isTablet: canUseDOM ? window.innerWidth <= 850 && window.innerWidth >= 767 : false,
            isDesktop: canUseDOM ? window.innerWidth > 850 : true,
            isMiddle: canUseDOM ? window.innerWidth < 767 && window.innerWidth > 450 : false,
            isSegmentedCollapsed: canUseDOM ? window.innerWidth <= 1000 : false
        };

        this.sliderRefMore = React.createRef();
        this.sliderRefProposal = React.createRef();
        this.navigate = this.navigate.bind(this);
        this.toggleTab = this.toggleTab.bind(this);
        this.heroRef = React.createRef();
    }

    handleScrollDownloadAppVisibility = () => {
        if (!this.heroRef.current || !this.props.onToggleDownloadApp) return;

        const heroBottom = this.heroRef.current.getBoundingClientRect().bottom;
        const headerHeight = 80;
        const downloadAppHeight = 104;

        const isVisible = heroBottom - headerHeight - downloadAppHeight > 0;

        this.props.onToggleDownloadApp(isVisible);
    };

    updateWidth = () => {
        this.setState({
            isMobile: window.innerWidth <= 450,
            isTablet: window.innerWidth <= 850 && window.innerWidth >= 767,
            isDesktop: window.innerWidth > 850,
            isMiddle: window.innerWidth < 767 && window.innerWidth > 450,
            isSegmentedCollapsed: window.innerWidth <= 1000
        });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
        window.addEventListener('scroll', this.handleScrollDownloadAppVisibility);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
        window.removeEventListener('scroll', this.handleScrollDownloadAppVisibility);
    }

    toggleTab = tab => {
        this.setState({tab});
    };

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    static contextTypes = {
        app: PropTypes.object
    };

    static displayName = 'HomeNew';
}
